import './MeasurementUnit.css';

import React, { forwardRef, useContext, useEffect } from 'react';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';
import { fetchMeasurementUnit } from '../../../services/b2b-indicators-apiService';
import { Delete, Save } from '@mui/icons-material';
import B2BPaper from '../../b2b-common/B2BPaper';
import { ConvertFromTable, ConvertToTable } from './helper';
import ConversionModal from '../modal/ConversionModal';

const MeasurementUnit = forwardRef(({ quantitativeMeasurementUnitId, className, onClose }, ref) => {

    const { loginData } = useContext(LoginContext);
    const [selectedMeasurementUnit, setSelectedMeasurementUnit] = React.useState(null);
    const [openConversionModal, setOpenConversionModal] = React.useState(false);
    const [selectedConversion, setSelectedConversion] = React.useState(null);

    const getMeasurementUnit = async () => {
        if (!quantitativeMeasurementUnitId || !loginData.accessToken) return;
        try {
            const qmu = await fetchAPIDataWhileSettingState(fetchMeasurementUnit, [quantitativeMeasurementUnitId, loginData.accessToken]);
            setSelectedMeasurementUnit(qmu);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getMeasurementUnit();
    }, [quantitativeMeasurementUnitId, loginData.accessToken]);

    const handleRemoveUnit = () => {
        console.log('Remove Unit');
    }

    const handleAddUnit = () => {
        console.log('Save & Close');
    }

    const buttonsConfig = [
        {
            label: 'Remove Unit',
            confirm: true,
            onConfirm: handleRemoveUnit,
            color: 'secondary',
            variant: 'contained',
            key: '2',
            icon: <Delete />,
        },
        {
            label: 'Save & Close',
            onClick: handleAddUnit,
            color: 'primary',
            variant: 'contained',
            key: '1',
            icon: <Save />,
        },
    ];

    const handleSelectConversionTo = (conversion) => {
        console.log('Selected Conversion:', conversion);
        setSelectedConversion(conversion);
        setOpenConversionModal(true);
    }

    const handleUpdatedConversion = async () => {
        await getMeasurementUnit();
        setOpenConversionModal(false);
    }

    return (
        selectedMeasurementUnit && (
            <>
                <B2BFormContainer
                    ref={ref}
                    title={`Measurement Unit: ${selectedMeasurementUnit.quantitativeMeasurementUnitName}`}
                    onClose={onClose}
                    buttonsConfig={buttonsConfig}
                    className="measurement-unit-form"
                >
                    {selectedMeasurementUnit.convertToUnits && selectedMeasurementUnit.convertToUnits.length > 0 && (
                        <B2BPaper elevation={0} className='measurement-unit-convert-from'>
                            <ConvertToTable
                                convertToUnits={selectedMeasurementUnit.convertToUnits}
                                onSelectConversion={handleSelectConversionTo}
                            />
                        </B2BPaper>
                    )}
                    <B2BPaper elevation={0} className='measurement-unit-details'>
                        <LabelTranslated
                            field="Name" labelValue={selectedMeasurementUnit.quantitativeMeasurementUnitName_label}
                            locale={`Short name - ${loginData.locale}`} translation={selectedMeasurementUnit.quantitativeMeasurementUnitName} />
                        <LabelTranslated
                            field="Unit" labelValue={selectedMeasurementUnit.quantitativeMeasurementUnit_label}
                            locale={`Short name - ${loginData.locale}`} translation={selectedMeasurementUnit.quantitativeMeasurementUnit} />
                    </B2BPaper>
                    {selectedMeasurementUnit.convertFromUnits && selectedMeasurementUnit.convertFromUnits.length > 0 && (
                        <B2BPaper elevation={0} className='measurement-unit-convert-to'>
                            <ConvertFromTable
                                convertFromUnits={selectedMeasurementUnit.convertFromUnits}
                                onSelectConversion={handleSelectConversionTo}
                            />
                        </B2BPaper>
                    )}
                </B2BFormContainer>
                <ConversionModal
                    open={openConversionModal}
                    onClose={() => setOpenConversionModal(false)}
                    toChangeConversion={selectedConversion}
                    onUpdate={handleUpdatedConversion}
                />
            </>
        )
    );
});

MeasurementUnit.displayName = 'MeasurementUnit';

export default MeasurementUnit;